import * as _ from 'lodash';

import {
    Component,
    ElementRef,
    Input,
    Output,
    OnInit,
    OnDestroy,
    EventEmitter,
    Renderer2,
    ViewEncapsulation
} from '@angular/core';

import { ModalOptions, Size, Backdrop, Position, Layer } from './types';
import { ModalService } from 'services';

@Component({
    selector: 'fc-modal',
    template: `<div
        [id]="id"
        class="fc-modal fc-modal-{{ layer }}-layer fc-modal-background"
        (click)="closeOnBackgroundClick($event)"
    >
        <div class="fc-modal-overlay {{ size }} {{ position }}">
            <ng-content></ng-content>
        </div>
    </div>`,
    styleUrls: ['./modal.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @Input() options?: ModalOptions;
    @Output() onClose = new EventEmitter<void>();

    private transitiveData?: any;
    private element;

    constructor(
        private modalService: ModalService,
        el: ElementRef,
        private renderer: Renderer2
    ) {
        this.element = el.nativeElement;
    }

    ngOnInit(): void {
        if (!this.id) {
            console.error(`${this.id} is not a valid modal id`);
            return;
        }

        if (!this.options) {
            this.options = {} as any;
        }

        this.renderer.appendChild(document.body, this.element);
        this.modalService.add(this);
    }

    ngOnDestroy(): void {
        this.modalService.remove(this.id);
        this.renderer.removeChild(document.body, this.element);
    }

    public open(): void {
        this.renderer.addClass(this.element, 'fc-modal-show');
        this.renderer.addClass(document.body, 'fc-modal-show');
    }

    public close(): void {
        this.onClose.emit();
        this.renderer.removeClass(this.element, 'fc-modal-show');
        this.renderer.removeClass(document.body, 'fc-modal-show');
    }

    public setData(data: any): void {
        this.transitiveData = data;
    }

    public closeOnBackgroundClick(event): void {
        if (!_.includes(event.target.classList, 'fc-modal-background')) {
            return;
        }
        if (this.options.backdrop === Backdrop.Static) {
            return;
        }
        this.onClose.emit();
        this.close();
    }

    get size(): Size {
        return _.get(this.options, 'size', Size.Md);
    }

    get position(): Position {
        return _.get(this.options, 'position', Position.Top);
    }

    get layer(): Layer {
        return _.get(this.options, 'layer', Layer.Back);
    }

    get data(): any {
        return this.transitiveData;
    }
}
